import { request, Response } from '../utils';

export const createAccount = (body: {
  email: string;
  username: string;
  password: string;
}): Response<null> => request('create-account', body);
